module.exports = __webpack_public_path__ + "static/media/PandaExpress-ChineseNewYear.cea06ad3.jpg";